<template>
    <v-dialog v-model="internalDialog" max-width="500px">
        <v-card>
            <v-card-title class="headline">Confirmación</v-card-title>
            <v-card-text>
                {{ mensajeConfirm }}
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn id="boton-verde"  @click="cancelar">Cancelar</v-btn>
            <v-btn id="boton-verde"  @click="confirmar">Aceptar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<style src="../assets/general.css"></style>
<script>
export default {
    name: "ConfirmacionDialog",
    props: {
        dialogConfirm: {
            type: Boolean,
            required: true
        },
        mensajeConfirm: {
            type: String,
            required: true
        }
    },
    computed: {
        internalDialog: {
            get() {
                return this.dialogConfirm;
            },
            set(val) {
                if (!val) this.$emit('cancelar');
            }
        }
    },
    methods: {
        cancelar() {
            this.$emit("cancelar");
        },
        confirmar() {
            this.$emit("confirmar");
        }
    }
};
</script>